export default __webpack_public_path__ + "static/media/team_notification.0b2e497f.png";